import type { PlainProject } from "@/queries/project-queries";
import { getUserId } from "@/utils/subjects";

/**
 * Collects deduplicated user IDs from a project's creator and usedBy subjects.
 * Only returns IDs for user principals (not service accounts).
 */
export function collectProjectUserIds(projects: PlainProject[]): string[] {
    const ids = new Set<string>();
    for (const project of projects) {
        const creatorId = getUserId(project.metadata?.creator);
        if (creatorId) ids.add(creatorId);
        for (const subject of project.usedBy?.subjects ?? []) {
            const uid = getUserId(subject);
            if (uid) ids.add(uid);
        }
    }
    return Array.from(ids);
}
